import {Button, Toolbar, ToolbarItem} from "@progress/kendo-react-buttons"
import {DropDownList, DropDownListChangeEvent} from "@progress/kendo-react-dropdowns"
import {Field, FieldRenderProps, Form, FormElement, FormRenderProps} from "@progress/kendo-react-form"
import {Input, Switch} from "@progress/kendo-react-inputs"
import {Error, FloatingLabel, Hint} from "@progress/kendo-react-labels"
import {
    MDBBtn,
    MDBCol,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
} from "mdbreact"
import {useState} from "react"
import {
    addTestStation,
    Dealer,
    editTestStation,
    setDealerDefaultSet,
    toggleAddEditModal,
} from "../../../containers/TestStation/testStationSlice"
import {RootState} from "../../../rootReducer"
import {SpinnerFragment} from "../../../shared/CommonItems"
import {useAppDispatch, useAppSelector} from "../../../store"

import AlertToastr from "../../Shared/alertToastr"
import {PermissionsChecker} from "../../Shared/permissionChecker"

const emailRegex: RegExp = new RegExp(/\S+@\S+\.\S+/)
const emailValidator = (value: string) => (emailRegex.test(value) ? "" : " ")
const EmailInput = (fieldRenderProps: FieldRenderProps) => {
    const {validationMessage, visited, label, id, valid, value, disabled, ...others} = fieldRenderProps
    const showValidationMessage = visited && validationMessage
    return (
        <>
            <FloatingLabel
                label={label}
                editorValue={value}
                editorValid={valid}
                editorDisabled={disabled}
                editorId={id}
            >
                <Input value={value} valid={valid} type={"email"} id={id} disabled={disabled} {...others} />
            </FloatingLabel>
            {showValidationMessage && <Error>{validationMessage}</Error>}
        </>
    )
}
const AddEditTS = () => {
    const dispatch = useAppDispatch()

    const isAddEditModalOpen = useAppSelector((state: RootState) => state.containers.testStations.isAddEditModalOpen)
    const isModalLoading = useAppSelector((state: RootState) => state.containers.testStations.isModalLoading)
    const selectedTestStation = useAppSelector((state: RootState) => state.containers.testStations.selectedTestStation)
    const dealers = useAppSelector((state: RootState) => state.containers.testStations.dealers)
    const dealerDefaultSet = useAppSelector((state: RootState) => state.containers.testStations.dealerDefaultSet)
    const isFetchingDealers = useAppSelector((state: RootState) => state.containers.testStations.gettingDealers)
    const userDealers = useAppSelector((state: RootState) => state.application.userDealers)

    const [dealerNotSelected, setDealerNotSelected] = useState(false)
    const [defaultATF, setDefaultATF] = useState(false)
    const requiredValidator = (value: string): string =>
        value && value.trim() ? "" : "Please enter a valid Test Station name"

    const testStationSubmit = (e: any) => {
        let testStation = {
            ...e,
            testStationName: e.testStationName.trim(),
            dealerDefault: defaultATF || e.dealerID === 0 ? false : e.dealerDefault,
        }

        dispatch(testStation.testStationID === 0 ? addTestStation(testStation) : editTestStation(testStation))
    }
    const isDealerAssigned =
        selectedTestStation.dealerID > 0 ? userDealers.some(a => a.dealerId === selectedTestStation.dealerID) : true

    const isATFSwitch = (props: FieldRenderProps) => {
        let {name, value, onChange} = props
        value = defaultATF ? defaultATF : value

        return (
            <Switch
                name={name}
                checked={value && !dealerNotSelected}
                onChange={onChange}
                value={value && !dealerNotSelected}
                disabled={dealerDefaultSet || !isDealerAssigned || dealerNotSelected}
            />
        )
    }

    const dealerDropDown = (fieldRenderProps: FieldRenderProps) => {
        let {name, label, data, textField, dataItemKey, loading, onChange, value} = fieldRenderProps

        const onChangeEV = (event: DropDownListChangeEvent) => {
            value = event.value.dealerId
            setDealerNotSelected(event.value.dealerId === 0)
            onChange({...event, value: value})
            dispatch(setDealerDefaultSet(false))
        }

        return (
            <>
                <DropDownList
                    name={name}
                    label={label}
                    data={data}
                    value={data.find((t: Dealer) => t.dealerId === value)}
                    textField={textField}
                    dataItemKey={dataItemKey}
                    loading={loading}
                    onChange={onChangeEV}
                    disabled={!isDealerAssigned}
                />
            </>
        )
    }
    return (
        <>
            <AlertToastr />
            <MDBModal staticBackdrop animationDirection="right" show={isAddEditModalOpen} tabIndex="-1">
                <MDBModalDialog position="top right modal-lg" side>
                    <MDBModalContent className="full-height ">
                        <MDBModalHeader titleClass="lead">
                            <MDBModalTitle>Test Station</MDBModalTitle>
                            <MDBBtn
                                color="none"
                                className="btn-close"
                                onClick={() => {
                                    setDefaultATF(false)
                                    dispatch(toggleAddEditModal(false))
                                }}
                            ></MDBBtn>
                        </MDBModalHeader>
                        {isModalLoading && <SpinnerFragment />}
                        {isAddEditModalOpen && (
                            <Form
                                key={JSON.stringify(selectedTestStation)}
                                initialValues={selectedTestStation}
                                onSubmit={testStationSubmit}
                                render={(formRenderProps: FormRenderProps) => (
                                    <FormElement className="w-100">
                                        <PermissionsChecker permission={["TestStations.Edit"]}>
                                            <Toolbar className="shadow-0 border-bottom p-0 pb-1 pt-1  position-sticky top-0">
                                                <ToolbarItem>
                                                    <Button
                                                        disabled={!formRenderProps.allowSubmit || isModalLoading}
                                                        type="submit"
                                                        fillMode="flat"
                                                        themeColor={"primary"}
                                                        iconClass="fa fa-save"
                                                        title="save"
                                                    >
                                                        Save
                                                    </Button>
                                                </ToolbarItem>
                                            </Toolbar>
                                        </PermissionsChecker>

                                        <MDBModalBody className="modal-overflow">
                                            <fieldset className={"k-form-fieldset mt-0"}>
                                                <Input name="testStationID" type="hidden" />
                                                <MDBRow>
                                                    <MDBCol md="12">
                                                        <Field
                                                            validator={requiredValidator}
                                                            tabIndex={1}
                                                            name={"testStationName"}
                                                            component={Input}
                                                            label="Test Station Name"
                                                        />
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol md="6">
                                                        <Field name={"email"} component={EmailInput} label={"E-mail"} />
                                                    </MDBCol>
                                                    <MDBCol md="6">
                                                        <Field name={"phone"} component={Input} label={"Phone No"} />
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol md="12">
                                                        <Field name={"address1"} component={Input} label={"Address"} />
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol md="12">
                                                        <Field name={"address2"} component={Input} label={"Address2"} />
                                                    </MDBCol>
                                                </MDBRow>
                                                <MDBRow>
                                                    <MDBCol md="6">
                                                        <Field name={"town"} component={Input} label={"Town"} />
                                                    </MDBCol>
                                                    <MDBCol md="6">
                                                        <Field
                                                            name={"postCode"}
                                                            component={Input}
                                                            label={"Post Code"}
                                                        />
                                                    </MDBCol>
                                                </MDBRow>

                                                <MDBRow className="pt-3">
                                                    <MDBCol md="6">
                                                        <Field
                                                            name={"dealerID"}
                                                            label={"Dealers with local ATF"}
                                                            component={dealerDropDown}
                                                            value={selectedTestStation.dealerID}
                                                            data={dealers}
                                                            textField="dealerName"
                                                            dataItemKey="dealerId"
                                                            loading={isFetchingDealers}
                                                        />
                                                    </MDBCol>
                                                    <MDBCol md="6">
                                                        <MDBCol md="7">Mark this as default Test Station </MDBCol>
                                                        <Field
                                                            name={`dealerDefault`}
                                                            component={isATFSwitch}
                                                            id={"dealerDefault"}
                                                        />
                                                    </MDBCol>
                                                </MDBRow>
                                                <Hint className="text-muted">
                                                    {!isDealerAssigned && (
                                                        <>Dealer cannot be modified because it is not assigned to you</>
                                                    )}
                                                </Hint>
                                            </fieldset>
                                        </MDBModalBody>
                                    </FormElement>
                                )}
                            />
                        )}
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </>
    )
}

export default AddEditTS
